import { useEffect, useState } from 'react';
import { useUnit } from 'effector-react';
import { Button, ButtonSize, ButtonType } from '@nx-frontend/shared/ui/button';
import { UiInput, UiInputView } from '@nx-frontend/shared/ui/input';
import { $existingSlugs } from '@nx-frontend/shared/store/feature-menu-tree';
import { EditPortalPagePayload } from '@nx-frontend/shared/types';
import { capitalizeFirstLetter, isValidInternalUrl } from '@nx-frontend/shared/utils';

export function EditPortalPagePopup({ content }: { content: EditPortalPagePayload }) {
  const [name, setName] = useState(content.name);
  const [url, setUrl] = useState(content.url);
  const [pageUrlError, setPageUrlError] = useState(false);
  const { type, showUrl } = content;
  const [existingSlugs] = useUnit([$existingSlugs]);
  const [filteredSlugs, setFilteredSlugs] = useState<string[]>([]);
  const [errorText, setErrorText] = useState<string | false>(false);

  useEffect(() => {
    if (url) {
      setUrl(url);
      setFilteredSlugs(existingSlugs.filter((slug) => slug !== url));
    }
  }, [existingSlugs, url]);

  return (
    <div className="inline-flex	p-[0] flex-col items-start rounded gap-4">
      <div className="flex flex-col gap-4">
        <div className="w-[356px] ">
          <UiInput
            id={`${type}_name`}
            type="text"
            label={`${capitalizeFirstLetter(type)} name`}
            value={name}
            name={`${type}_name`}
            error={false}
            placeholder={`Enter ${type} name`}
            view={UiInputView.LABEL_TOP}
            onChange={(e) => {
              setName(e.target.value);
            }}
          />
        </div>
        {showUrl !== false ? (
          <div className="w-[356px] ">
            <UiInput
              id={`${type}_url`}
              type="text"
              label={`${capitalizeFirstLetter(type)} Url`}
              value={url}
              name={`${type}_url`}
              error={pageUrlError}
              errorText={errorText ? errorText : undefined}
              placeholder={`Enter ${type} url`}
              view={UiInputView.LABEL_TOP}
              onChange={(e) => {
                setUrl(e.target.value);
                if (!isValidInternalUrl(e.target.value) || filteredSlugs.includes(e.target.value)) {
                  setPageUrlError(true);
                  setErrorText(e.target.value ? 'URL already exists' : false);
                } else {
                  setPageUrlError(false);
                }
              }}
            />
          </div>
        ) : null}
        <div className="w-full flex justify-end gap-[12px]">
          <Button
            size={ButtonSize.SM}
            type={ButtonType.FLAT}
            disabled={pageUrlError}
            onClick={() => !pageUrlError && content.onSave(name, url)}
          >
            Save
          </Button>
          <Button size={ButtonSize.SM} type={ButtonType.STROKED} onClick={content.onWantToClose}>
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );
}
